export const PERSONAL_BODY = "PERSONAL_BODY";
export const PARTNER_BODY = "PARTNER_BODY";
